import { Button, Dropdown } from 'antd';
import { TbDotsVertical, TbLogout } from 'react-icons/tb';

import { useAccountSessionManager } from '@/hooks/useAccountSessionManager';
import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

interface AccountActionsDropdownProps {
    accountId: string;
    emailAddress: string;
    disabled: boolean;
}

export default function AccountActionsDropdown({ accountId, emailAddress, disabled }: AccountActionsDropdownProps) {
    const { logoutAccounts } = useAccountSessionManager();
    const { token } = useAntDesignTheme();
    return (
        <span onClick={(event) => event.stopPropagation()} onKeyDown={(event) => event.stopPropagation()}>
            <Dropdown
                trigger={['click']}
                placement='bottomRight'
                disabled={disabled}
                destroyOnHidden
                menu={{
                    'aria-label': `Actions for ${emailAddress}`,
                    items: [
                        {
                            key: 'sign-out-account',
                            label: 'Sign Out of This Account',
                            icon: <TbLogout size='1rem' />,
                            disabled,
                            onClick: ({ domEvent }) => {
                                domEvent.stopPropagation();
                                void logoutAccounts([accountId]);
                            },
                        },
                    ],
                }}
            >
                <Button
                    aria-label={`Account actions for ${emailAddress}`}
                    disabled={disabled}
                    icon={<TbDotsVertical size='1rem' color={token.colorTextTertiary} />}
                    size='small'
                    type='text'
                />
            </Dropdown>
        </span>
    );
}
